module.exports = __webpack_public_path__ + "static/media/9.4c9c4a16.jpeg";